var _text, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDizlogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_22_1",
    "data-name": "Component 22 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 41,
    viewBox: "0 0 166 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Enterprise_Platform",
    "data-name": "Enterprise  Platform",
    transform: "translate(88 17)",
    fontSize: 16,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Enterprise "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "Platform"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M285.782,283.4v-6.74a11.922,11.922,0,1,0,.011-23.844l-5.594.088-.1-6.739,5.646-.088a18.662,18.662,0,1,1,.042,37.323Z",
    transform: "translate(-275.409 -246.074)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2621",
    "data-name": "Rectangle 2621",
    width: 6.525,
    height: 37.266,
    transform: "translate(33.086 0.07)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2622",
    "data-name": "Rectangle 2622",
    width: 6.74,
    height: 37.287,
    transform: "translate(0 0.049)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(46.067 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M333.738,255.633a15.354,15.354,0,0,0-17.76-.074l-4.057-5.11a21.838,21.838,0,0,1,25.933.121Z",
    transform: "translate(-311.921 -246.243)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M324.813,276.879a20.728,20.728,0,0,1-12.892-4.207l4.057-5.11a15.352,15.352,0,0,0,17.76-.073l4.116,5.062A20.64,20.64,0,0,1,324.813,276.879Z",
    transform: "translate(-311.921 -239.764)",
    fill: "#0c78bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(49.578 10.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M329.479,256.714a7.107,7.107,0,0,0-.8-2.351,10.716,10.716,0,0,1-.907,2.761",
    transform: "translate(-310.599 -254.362)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M327.789,263a7.1,7.1,0,0,0,2.9-6.736l-1.8.432c-.787,1.417-2.19,2.825-5.018,4.346",
    transform: "translate(-311.787 -253.783)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M322.316,265.28c2.742-1.053,5.432-2.221,6.62-3.305l-3.9-1.965c-.552.3-1.157.6-1.822.9a34.645,34.645,0,0,0-3.658,1.961",
    transform: "translate(-313.103 -252.64)",
    fill: "#7bb94f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M315.148,268.262c1.3-1.219,4.772-2.2,8.327-3.579l-2.717-2.391c-5.072,2.881-5.61,5.97-5.61,5.97",
    transform: "translate(-314.448 -251.944)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M326.1,259.313a8.828,8.828,0,0,0,3.005-4.951,17.043,17.043,0,0,1-3.231,1.589",
    transform: "translate(-311.178 -254.362)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M317.3,259.942c-4.4,3.534-2.067,8.976-2.067,8.976a7.356,7.356,0,0,1,2.85-4.463",
    transform: "translate(-314.612 -252.66)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M321.505,262.362c.378-.191.545-.3.964-.489a23.71,23.71,0,0,0,4.843-2.842l-.222-3.4c-1.92.856-3.887,1.5-5.767,2.365",
    transform: "translate(-312.565 -253.974)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M317.594,265.045a25.941,25.941,0,0,1,5.1-3.176l-.206-4.356c-.955.4-2.208,1.024-2.8,1.309a12.617,12.617,0,0,0-2.869,1.739",
    transform: "translate(-313.937 -253.401)",
    fill: "#5cae3e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDizlogoMobile);
export default __webpack_public_path__ + "static/media/dizlogoMobile.2552e9f1bbb6cc7b74cfa2f7411fd5d8.svg";
export { ForwardRef as ReactComponent };